import { useMemo } from "react";
import { createViewport } from "../utils/viewport";

// React binding over the pure projection in utils/viewport.js. Returns one
// memoised viewport per layout, all from the same canvas size. antd Tabs keep
// hidden panes mounted, so each canvas must project with ITS OWN viewport;
// only the pointer handlers pick the active layout's one.
//
// `view` is the editor's zoom/pan (useEditorMode). Only the plane viewport
// takes it -- line and tunnel have no zoom -- and because every plane
// pixel <-> metre conversion in the editor goes through this one viewport,
// drags and clicks land on the same metres at any zoom.
export const useCoordinateConversion = (dimensions, canvasSize, view) => {
  const zoom = view?.zoom;
  const pan = view?.pan;
  return useMemo(
    () => ({
      plane: createViewport({
        dimensions,
        canvasSize,
        layoutType: "plane",
        zoom,
        pan,
      }),
      line: createViewport({ dimensions, canvasSize, layoutType: "line" }),
      tunnel: createViewport({ dimensions, canvasSize, layoutType: "tunnel" }),
    }),
    [dimensions, canvasSize, zoom, pan],
  );
};
